import actions from './actions';
import mutations from './mutations';

const resales = {
    namespaced: true,
    state: {
        items: [],
        dealer: false,
        brandId: null,
        option: null
    },
    mutations,
    actions
};

export default resales;
